import Cookie from "../cookie";

const catalog = () => {

    const $catalog = $('.catalog');
    const $catalog_product = $('.catalog__product');
    const $filter_parent = $('.js-filter-parent');
    const $filter_child = $('.js-filter-child');
    const $tag_all = $catalog.find('.js-tag.tag-all');

    if (!$catalog.length) return;

    $catalog.find('.nice-select')
        .mouseenter(function() {
            $(this).addClass('open');
        })
        .mouseleave( function() {
            $(this).removeClass('open');
        });


    //filters
    $filter_parent.on('click', function () {

        let id = $(this).data('tag');
        $filter_child.hide();
        $catalog.find('[data-parent="'+ id +'"]').show();

        if($(window).width() > 576) {
            if($catalog.find('.selected').length > 0){
                $tag_all.show();
            }
            else {
                $tag_all.hide();
            }
        }

    });

    $filter_child.on('click', function () {
        if($(window).width() > 576) {
            if ($catalog.find('.selected').length > 0) {
                $tag_all.show();
            } else {
                $tag_all.hide();
            }
        }
    });

    $tag_all.on('click', function () {
        if($(window).width() > 576) {
            $(this).hide();
        }
    });

    $('.js-link').on('change', function () {

        window.location.href = $(this).find(':selected').attr('data-url');

    });

    if (Cookie.has('catalog_view')) {
        const view = Cookie.get('catalog_view');

        $catalog_product.removeClass('is-view-list is-view-tile').addClass('is-' + view);

        $('#' + view).addClass('is-active').siblings().removeClass('is-active');
    }



    $('.view-switch-btn').on('click', function () {
        const view = $(this).attr('id');
        const className = 'is-' + view;

        if (!$catalog_product.hasClass(className)) {
            Cookie.set('catalog_view', view, 30);

            $(this).addClass('is-active').siblings().removeClass('is-active');

            $catalog_product.removeClass('is-view-list is-view-tile').addClass(className);
        }
    });
};

export default catalog;
